module.exports = {
  path: 'import',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/SimcardImport'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/simcards/routes/import/index.js